<template lang="pug">
.map
  FcwEntitiesMap(
    :loading
    :stations
    :points-of-interest
    :area="areaData?.area"
    controls-position="bottom-right"
    height="100%"
    width="100%"
    @refresh-map="refreshMap"
  )
</template>

<style lang="stylus">
.map
  display flex
  position relative
  height 100vh
  padding-top 5rem
</style>

<script setup lang="ts">
import {
  MAP_DATA_REFRESH_INTERVAL,
  MAP_DATA_REFRESH_THROTTLE_DELAY,
} from '@/components/organisms/FcwEntitiesMap/config';

definePageMeta({
  layout: 'showcase',
  navPlainThreshold: 0,
  hideFooter: true,
});

const api = useApi();

const {
  data,
  loading: entitiesLoading,
  refresh: refreshEntities,
} = await api.get('/client/entities', {
  lazy: true,
});

// Refresh map's data every 30 seconds
const refreshEntitiesThrottled = useThrottleFn(
  refreshEntities,
  MAP_DATA_REFRESH_THROTTLE_DELAY
);

const { resume: start } = useIntervalFn(
  refreshEntities,
  MAP_DATA_REFRESH_INTERVAL
);

function refreshMap(): void {
  refreshEntitiesThrottled();

  start();
}

const stations = computed(() => data.value?.stations ?? []);
const pointsOfInterest = computed(() => data.value?.pointsOfInterest ?? []);

const { areaId } = useClientStore().clientState;

const { data: areaData, loading: areaLoading } = await api.get(
  `/client/areas/${areaId}`,
  {
    lazy: true,
  }
);

const loading = computed(() => entitiesLoading.value || areaLoading.value);

const { seoData } = await useCmsShowcaseMap();

useClientSeoMeta(seoData);
</script>
